import React from 'react'
import Background from './Background'
import PerfumeCard from './PerfumeCard'

const PerfumeToGreatness = () => {
  return (
   <Background>
    <PerfumeCard/>
   </Background>
  )
}

export default PerfumeToGreatness